/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  branch Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  ADD_BRANCH(state, branch) {
    state.branches.unshift(branch);
    state.totalDataRow++;
  },
  SET_BRANCH(state, res) {
    state.branches = res.items
    state.totalDataRow = res.totalCount;
  },
  UPDATE_BRANCH(state, branch) {
    const productIndex = state.branches.findIndex((p) => p.id == branch.id)
    Object.assign(state.branches[productIndex], branch)
  },
  REMOVE_BRANCH(state, branchId) {
    const branchIndex = state.branches.findIndex((p) => p.id == branchId)
    state.branches.splice(branchIndex, 1)
  }
}
